import { produce } from 'immer';

import {
    DEFAULT_COOKIE_NAME,
    STORAGE_COOKIE_NAME,
    COOKIE_EXPIRATION_DAYS,
    REMOVE_COOKIES_INTERVAL
} from '../constants';
import { actionTypes } from './constants';
import * as Types from './types';

export const defaultState: Types.ICookieSettingsState = {
    groupsData: {},
    isInitialSetup: true,
    isCommonCookieUpdated: false,
    defaultCookieName: DEFAULT_COOKIE_NAME,
    storageCookieName: STORAGE_COOKIE_NAME,
    cookieExpirationDays: COOKIE_EXPIRATION_DAYS,
    removeCookiesInterval: REMOVE_COOKIES_INTERVAL
};

export const reducer = produce((draftState, action: Types.TCookieSettingsAction): Types.ICookieSettingsState | void => {
    switch (action.type) {
        case actionTypes.SET_COOKIES_GROUPS: {
            Object.assign(draftState, {
                groupsData: action.payload,
                isInitialSetup: false
            });

            break;
        }

        case actionTypes.SET_COOKIES_GROUPS_INITIAL: {
            Object.assign(draftState, {
                groupsData: action.payload,
                isInitialSetup: true
            });

            break;
        }

        case actionTypes.SET_COMMON_COOKIE_FLAG: {
            Object.assign(draftState, {
                isCommonCookieUpdated: action.payload
            });

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
